<template>
  <div class="services-minis" :class="getOccupation">
    {{ room.name }} ({{ oPercent }} %)
    <span v-if="ms && cashState(ms)"> - {{ getTypeCash(cashState(ms).type) }} : {{ cashState(ms).value }}€ / c</span>
    <span v-if="cashState(ms).nbCouv">({{ cashState(ms).nbCouv }})</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { dateToTimeStamp } from '../../tools/timeTool';

export default {
  name: 'ServicesMini',
  props: ['room', 'ms', 'date'],
  data() {
    return {
      oPercent: 0
    }
  },
  computed: {
    ...mapGetters({
      getAllServices: 'newServices/getAllServices',
      getOccupationByServiceAndDayRoom: 'newReservations/getOccupationByServiceAndDayRoom',
      getRoomNbCouvertsLocked: 'newRooms/getRoomNbCouvertsLocked',
      getCashDaysList: 'cash/getCashDaysList',
      getSelectedDay: 'calendar/getSelectedDay'
    }),
    getOccupation: function () {
      let nbLockedCouv = this.getRoomNbCouvertsLocked({
        date: this.date,
        service: this.ms,
        room: this.room.id
      })
      let percent = Math.round((this.getOccupationByServiceAndDayRoom(this.date, this.ms, this.room.id) / (this.room.nbCouverts - nbLockedCouv)) * 100)
      this.oPercent = percent
      switch (true) {
        case percent >= 0 && percent < 25:
          return 'green'
        case percent >= 25 && percent < 50:
          return 'yellow'
        case percent >= 50 && percent < 75:
          return 'orange'
        case percent >= 75 && percent <= 100:
          return 'red'
        case percent > 100:
          return 'red-dark'
      }
    }
  },
  methods: {
    cashState: function (service) {
      let date = new Date(this.date.date)
      let ts = dateToTimeStamp(date.getDate(), date.getMonth(), date.getFullYear())
      let cashList = this.getCashDaysList
      // get current service
      let serviceForDay = null
      if (this.getAllServices[service]) serviceForDay = this.getAllServices[service][this.getSelectedDay.labelDay]

      if (service && cashList && cashList[ts] && cashList[ts][service]) return cashList[ts][service]
      else if (serviceForDay && serviceForDay.cashOn) {
        return {
          type: serviceForDay.cashType,
          value: serviceForDay.cashPrice,
          isOnService: true
        }
      } else return ''
    },
    getTypeCash: function (type) {
      if (type === 'caution') return 'C'
      else return 'P'
    }
  }
}
</script>

<style lang="scss"></style>
